<template>
  <div class="profile">
    <div class="">
      {{ $t("point.profile") }}
      <i
        class="fas fa-edit edit"
        size="mini"
        @click="showEditForm()"
        v-show="!editing"
      ></i>
    </div>
    <div class="body" v-loading="loading">
      <div
        style="text-align: center"
        class="info"
        v-if="!point.profile && !editing"
      >
        {{ $t("point.noProfilFound") }}
      </div>
      <ul v-if="point.profile && !editing">
        <el-col :span="24">
          <li>
            <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
              $t("point.sampleSize")
            }}</span>
            <br />
            <span>{{ point.profile.sampleSize }}</span>
          </li>
          <li>
            <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
              $t("point.sampleRate")
            }}</span>
            <br />
            <span
              >{{ point.profile.samplingRate.value }}
              {{ point.profile.samplingRate.unit }}</span
            >
          </li>
          <li>
            <span style="font-size: 10px; color: rgb(128, 128, 128)">{{
              $t("point.accelerometerRange")
            }}</span>
            <br />
            <span
              >{{ point.profile.accelerometerRange.value }}
              {{ point.profile.accelerometerRange.unit }}</span
            >
          </li>
        </el-col>
      </ul>
      <el-form
        v-if="editing"
        label-position="top"
        label-width="100px"
        :model="form"
        ref="form"
        :rules="rules"
      >
        <el-row>
          <el-col class="resolutionSwich" :span="24">
            <el-form-item>
              <el-switch v-model="resolutionvalue"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('point.sampleSize')">
              <el-input-number
                :disabled="resolutionvalue"
                v-model="form.sampleSize"
                :min="10"
                :max="50000"
                :step="10"
              />
            </el-form-item>
            <el-form-item :label="$t('point.sampleRate')">
              <el-select
                v-model="form.samplingRate"
                placeholder="Select"
                :disabled="resolutionvalue"
              >
                <el-option
                  v-for="item in configurations.samplingRates"
                  :label="`${item.value} ${item.unit}`"
                  v-bind:key="item.index"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('point.specRes')">
              <el-input-number
                :disabled="!resolutionvalue"
                v-model="freqRes"
                :min="form.samplingRate.value / 20000"
                :max="form.samplingRate.value / 100"
                :step="1"
              />
            </el-form-item>
            <el-form-item :label="$t('point.bandWide')">
              <el-select
                v-model="form.samplingRate"
                placeholder="Select"
                :disabled="!resolutionvalue"
              >
                <el-option
                  v-for="item in configurations.samplingRates"
                  :label="`${item.value / 2} ${item.unit}`"
                  v-bind:key="item.index"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('point.accelerometerRange')">
              <el-select v-model="form.accelerometerRange" placeholder="Select">
                <el-option
                  v-for="item in configurations.accelerometerRanges"
                  :label="`${item.value} ${item.unit}`"
                  v-bind:key="item.index"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-button
          v-if="checkPermission('updatePointConfig')"
          size="mini"
          @click="save()"
          >{{ $t("point.save") }}</el-button
        >
        <el-button size="mini" @click="editing = false">{{
          $t("point.cancel")
        }}</el-button>
        <el-button
          v-if="checkPermission('deletePointConfig') && point.profile"
          size="mini"
          style="float: right"
          type="danger"
          @click="deleteIt()"
          >{{ $t("common.delete") }}</el-button
        >
      </el-form>
    </div>
    <br />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Profile",
  props: ["point"],
  data() {
    return {
      // showEditProfile: false
      bodyStyle: {
        padding: "5px",
      },
      resolutionvalue: true,
      loading: false,
      form: {
        samplingRate: "",
        sensorSelection: "",
        accelerometerRange: "",
        window: "",
        sampleSize: 1000,
      },
      samplesizefreqRes: 0,
      freqRes: "",
      editing: false,
      rules: {
        sampleSize: [
          {
            required: true,
          },
        ],
      },
    };
  },
  created() {},
  computed: {
    ...mapState("deviceConfigurations", ["configurations"]),
  },
  watch: {
    "form.sampleSize"() {
      if (!this.resolutionvalue) {
        this.freqRes = (
          this.form.samplingRate.value / this.form.sampleSize
        ).toFixed(4);

        this.form.sampleSize = parseInt(
          this.form.samplingRate.value / this.freqRes
        );
      }
    },
    "form.samplingRate"() {
      if (!this.resolutionvalue) {
        this.freqRes = (
          this.form.samplingRate.value / this.form.sampleSize
        ).toFixed(4);
      } else {
        this.form.sampleSize = parseInt(
          this.form.samplingRate.value / this.freqRes
        );
      }
    },
    resolutionvalue() {
      this.freqRes = (
        this.form.samplingRate.value / this.form.sampleSize
      ).toFixed(4);
    },
    freqRes() {
      if (this.resolutionvalue) {
        this.form.sampleSize = parseInt(
          this.form.samplingRate.value / this.freqRes
        );
      }
    },
  },
  methods: {
    ...mapActions("point", ["updateProfile", "deleteProfile"]),
    deleteIt() {
      this.loading = true;
      this.$confirm(this.$t("point.areYouSure?"), this.$t("point.warning"), {
        confirmButtonText: this.$t("point.ok"),
        cancelButtonText: this.$t("point.cancel"),
        type: "warning",
      })
        .then(() => this.deleteProfile(this.point._id))
        .then(() => {
          this.loading = false;
          this.editing = false;
          this.$message({
            type: "success",
            message: this.$t("point.DeleteCompleted"),
          });
        })
        .finally(() => (this.loading = false));
    },
    save() {
      this.loading = true;
      this.updateProfile({
        pointId: this.point._id,
        profile: this.form,
      })
        .then(() => {
          this.editing = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showEditForm() {
      if (this.point.profile) {
        this.form = {
          samplingRate: this.point.profile.samplingRate,
          sensorSelection: this.point.profile.sensorSelection,
          accelerometerRange: this.point.profile.accelerometerRange,
          sampleSize: this.point.profile.sampleSize,
        };
        this.freqRes = (
          this.form.samplingRate.value / this.form.sampleSize
        ).toFixed(4);
      } else {
        this.form = {
          samplingRate: this.configurations.samplingRates[0],
          sensorSelection: this.configurations.sensorSelections[0],
          accelerometerRange: this.configurations.accelerometerRanges[0],
          sampleSize: 1000,
        };
        this.freqRes = (
          this.form.samplingRate.value / this.form.sampleSize
        ).toFixed(4);
      }
      this.editing = true;
    },
  },
};
</script>
<style>
.profile .el-form--label-top .el-form-item__label {
  padding-bottom: 0px;
}
.profile .el-input-number__increase {
  right: -19px;
}
.profile .el-form-item__label {
  line-height: 0px;
  font-size: 12px;
}
.profile .el-form-item {
  margin-bottom: 18px;
}

.profile .el-input {
  width: 200px;
}

.info {
  padding: 10px;
  color: #232323;
  font-style: italic;
  font-size: 10px;
}
.point .el-card__header {
  padding: 10px;
}
</style>
<style  scoped>
.resolutionSwich {
  text-align: center;
}
.profile .header:hover .edit,
.el-card__header:hover .edit {
  opacity: 1;
}
.edit {
  display: inline-block;
  opacity: 0.5;
}
.profile {
  padding: 10px;
}
.profile .body li {
  list-style-type: none;
  margin-bottom: 10px;
}
.profile .header {
  font-size: 14px;
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(226, 226, 226);
}
.path {
  margin-left: 5px;
  line-height: -20px;
  font-size: 12px;
  color: gray;
}
.name {
  font-size: 20px;
  font-weight: bold;
}
.point {
  margin-bottom: 10px;
}
</style>